window.ttx = window.ttx || {};
ttx.simpleEvent = {};

/**
 * VTable 事件分发器
 *
 * 用法：
 *   const handlers = ttx.simpleEvent.createEventHandlers({
 *       click_cell: {
 *           link: (args) => console.log('link clicked', args),
 *           image: (args) => console.log('image clicked', args),
 *       },
 *       dblclick_cell: {
 *           link: (args) => console.log('link dblclicked', args),
 *       },
 *   });
 *
 *   // UI 组件中注册：
 *   Object.entries(handlers).forEach(([event, handler]) => {
 *       table.on(event, handler);
 *   });
 *
 *   // 销毁时：
 *   Object.entries(handlers).forEach(([event, handler]) => {
 *       table.off(event, handler);
 *   });
 */

/** 从 VTable 原始事件中提取上层需要的字段 */
function pickEventArgs(args) {
    console.log(args,'args');
    
    if (!args) return {};
    return {
        ...args,
    }
}

/** 按事件类型 + cellType 分发的工厂 */
function createCellTypeDispatcher(callbacksForEvent) {
    if (!callbacksForEvent || typeof callbacksForEvent !== 'object') return null;
    return function (args) {
        if (!args || !args.cellType) return;
        const cb = callbacksForEvent[args.cellType];
        if (typeof cb === 'function') {
            cb(pickEventArgs(args));
        }
    };
}

/**
 * 创建 VTable 所有事件的 handler 映射
 * @param {object} callbacks — { click_cell: { link: fn, image: fn }, dblclick_cell: { link: fn }, ... }
 * @returns {object} — { click_cell: fn, dblclick_cell: fn, ... }
 */
ttx.simpleEvent.createEventHandlers = function (callbacks) {
    if (!callbacks || typeof callbacks !== 'object') return {};

    var result = {};
    Object.keys(callbacks).forEach(function (eventName) {
        var handler = createCellTypeDispatcher(callbacks[eventName]);
        if (handler) result[eventName] = handler;
    });
    return result;
};

/**
 * 创建 CLICK_CELL 事件的 handler（createEventHandlers 的便捷版）
 * @param {object} cellCallbacks — { link: fn, image: fn, ... }
 * @returns {function} — click_cell handler
 */
ttx.simpleEvent.createCellClickHandler = function (cellCallbacks) {
    return createCellTypeDispatcher(cellCallbacks);
};
